import { GuardedDeletionService, MillService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MillCreateDto,
  MillDto,
  MillExcelDownloadDto,
  MillUpdateDto,
} from '../proxy/planning/dtos/mill';
import { MILL_CONFIG, MILL_FIELDS } from './mill.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mill',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, MillService, ConfirmationService],
  templateUrl: './mill.html',
  styleUrl: './mill.scss',
})
export class Mill extends BaseHierarchicalCrudComponent<
  MillDto,
  MillCreateDto,
  MillUpdateDto,
  MillExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(MillService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Mill', ids),
  };
  config = MILL_CONFIG;
  fields = MILL_FIELDS;

  protected prepareUpdateDto(data: any, selected: MillDto): MillUpdateDto {
    return {
      name: data.name,
      capacity: data.capacity,
      vendorId: data.vendorId,
      isEligibleForElectronicInvoice: data.isEligibleForElectronicInvoice,
      isDestinationWoodLog: data.isDestinationWoodLog,
      isTransferLogyard: data.isTransferLogyard,
      demandSaleContract: data.demandSaleContract,
      remsoftName: data.remsoftName,
      measurementTypeId: data.measurementTypeId,
      isActive: data.isActive,
      zoneId: data.zoneId,
      regionId: data.regionId,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Mill';
  }
}
